import { PencilSimpleLine } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IElement } from 'bom/types';
import { Button, IButtonProps } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IJob } from 'jobs/types';
import { Color } from 'theme/enums';

import { UpsertElement } from './UpsertElement';

interface IProps extends IButtonProps {
  job: IJob;
  element: IElement;
  buttonElement?: ReactElement;
}

export const EditElementButton = ({ job, element, buttonElement, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const onSubmitSuccess = async (element: IElement) => updateRows({ update: [element] });

  const handleOnClose = () => setIsOpen(false);

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelEditElement')}
        color={Color.PRIMARY}
        startDecorator={<PencilSimpleLine />}
        onClick={() => setIsOpen(true)}
        {...rest}
      />
    );
  }, [buttonElement, rest, t]);

  return (
    <>
      {button}

      <UpsertElement
        isOpen={isOpen}
        onClose={handleOnClose}
        jobId={job.id}
        element={element}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
